/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react'
import {
    Create,
    Edit,
    required,
    SimpleForm,
    TextInput,
    useNotify,
    useRefresh,
    useRedirect,
    useDataProvider,
} from 'react-admin'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import BackButton from '../../components/BackButton'
import SearchReferenceInput from '../../components/QuickSearch/QuickSearch'
import ProvinceList from '../Province/ProvinceList'
import Title from '../../components/Title/Title'
import '../style.css'
import CustomValidater from '../../components/Utility/Validater'

const CityComponent = (props) => {
    const user = useSelector((state) => state.auth)
    const userData = {
        created_by: user.description,
        modified_by: user.description,
    }
    const { isEdit, title, record } = props

    return (
        <SimpleForm
            validate={(values) => CustomValidater(values, props)}
            style={{ width: '100%' }}
            {...{ ...props, record: { ...record, ...userData } }}
            variant="outlined"
            warnWhenUnsavedChanges
            initialValues={userData}
        >
            <Title title={title} />
            <div className="container">
                <TextInput
                    style={{ display: 'flex', flex: 1 }}
                    variant="outlined"
                    label="Code"
                    source="code"
                    validate={[required()]}
                    disabled={isEdit}
                />
            </div>
            <div className="container">
                <TextInput
                    style={{ display: 'flex', flex: 1 }}
                    variant="outlined"
                    label="Description"
                    source="description"
                    validate={required()}
                />
            </div>
            <div className="container">
                <div
                    style={{
                        display: 'flex',
                        flex: 1,
                    }}
                >
                    <SearchReferenceInput
                        {...props}
                        source="province_id"
                        reference="Province"
                        allowEmpty
                        validate={required()}
                        perPage={10000}
                        list={ProvinceList}
                        resource="PY_ProvinceTAB"
                        basePath="/PY_ProvinceTAB"
                    />
                </div>
            </div>
            <div className="container">
                <TextInput
                    style={{ display: 'flex', flex: 0.49 }}
                    variant="outlined"
                    disabled
                    label="Created By"
                    source="created_by"
                    validate={required()}
                />
                <TextInput
                    style={{ display: 'flex', flex: 0.49 }}
                    variant="outlined"
                    disabled
                    label="Modified By"
                    source="modified_by"
                    validate={required()}
                />
            </div>
        </SimpleForm>
    )
}

export default function CreateCity(props) {
    const [province, setProvince] = useState([])
    const { isEdit } = props
    const notify = useNotify()
    const refresh = useRefresh()
    const redirect = useRedirect()
    const onSuccess = () => {
        notify(`Changes saved`, { type: 'success' })
        redirect('/PY_CityTAB')
        refresh()
    }
    const dataProvider = useDataProvider()
    useEffect(() => {
        dataProvider
            .getList('PY_ProvinceTAB', {})
            .then(({ data }) => {
                console.log('data', data)
                setProvince(data)
            })
            .catch((error) => {
                console.log('errr', error)
            })
    }, [])
    if (isEdit)
        return (
            <>
                <BackButton path="/PY_CityTAB" />
                <Edit {...props} undoable={false}>
                    <CityComponent
                        title="Edit City"
                        province={province}
                        isEdit
                    />
                </Edit>
            </>
        )
    return (
        <>
            <BackButton path="/PY_CityTAB" />
            <Create onSuccess={onSuccess} {...props}>
                <CityComponent
                    title="Create City"
                    province={province}
                    isEdit={false}
                />
            </Create>
        </>
    )
}

CreateCity.propTypes = {
    isEdit: PropTypes.bool.isRequired,
}

CityComponent.propTypes = {
    isEdit: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    record: PropTypes.objectOf(PropTypes.any).isRequired,
}
